// This file contains compile-time defined variables.

export const NAME: string = "zippycli";

export const VERSION: string = "1.4.2";
